<script setup lang="ts">
import Toast from 'primevue/toast';

import BookingPage from '@/pages/booking/BookingPage.vue';

const match = window.location.pathname.match(/^\/quick-quote\/([^/]+)\/?$/);
const apiKey = match?.[1] ? decodeURIComponent(match[1]) : '';
const isModal =
	new URLSearchParams(window.location.search).get('modal') === '1' &&
	window.parent !== window;

const closeModal = (): void => {
	window.parent.postMessage({ type: 'gb-quick-quote:close' }, '*');
};
</script>

<template>
	<BookingPage
		v-if="apiKey"
		:apiKey="apiKey"
		:closable="isModal"
		@close="closeModal"
	/>
	<main
		v-else
		class="tw3-flex tw3-min-h-screen tw3-items-center tw3-justify-center tw3-bg-surface-50 tw3-p-6 tw3-text-center tw3-text-surface-900"
	>
		<div>
			<h1 class="tw3-text-2xl tw3-font-bold">Invalid booking link</h1>
			<p class="tw3-mt-2 tw3-text-sm tw3-text-surface-500">
				Check the link and try again.
			</p>
		</div>
	</main>
	<Toast position="top-center" :pt="{ root: { style: 'top: 62px' } }" />
</template>
